import { api, IApprovalMatrixApi } from "@/main/api/base";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { Result } from "@/main/models/common/resultResponse";
import { ApprovalMatrixFilterRequest, ApprovalMatrixSaveRequest } from "@/main/models/request";
import {
	ApprovalMatrixDetailsResponse,
	ApprovalMatrixSaveResponse,
	ApprovalMatrixSearchResponse,
} from "@/main/models/response";
import { AxiosResponse } from "axios";

const baseRoute: string = "ApprovalMatrix";

export class ApprovalMatrixApi implements IApprovalMatrixApi {
	searchGrid(
		request: ApprovalMatrixFilterRequest,
	): Promise<AxiosResponse<PaginationResponse<ApprovalMatrixSearchResponse>>> {
		return api.get(`${baseRoute}/search-grid`, { params: request });
	}

	getDetails(guidApprovalMatrix: string): Promise<AxiosResponse<Result<ApprovalMatrixDetailsResponse>>> {
		return api.get(`${baseRoute}`, { params: { guid: guidApprovalMatrix } });
	}

	save(request: ApprovalMatrixSaveRequest): Promise<AxiosResponse<Result<ApprovalMatrixSaveResponse>>> {
		return api.post(`${baseRoute}/save`, request);
	}
}
